export enum HTTPMethod {
  GET = `GET`,
  POST = `POST`,
  PUT = `PUT`,
  DELETE = `DELETE`,
  PATCH = `PATCH`,
}

export enum HTTPStatus {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
}
